let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dSZ60")).then(() => parcelRequire('bsJdy'));